import { TextWrapper } from './styled';
import { Text } from '@simplywallst/ui-core';

export const AnalystTargetColumnHeaderTooltip = () => (
  <TextWrapper rowGap="8px">
    <Text typography="tiny" color="spaceGray">
      The average price target provided by all the analyst projections of a
      company's future price
    </Text>
  </TextWrapper>
);
